﻿import CreditCardProvider from "../../enums/CreditCardProvider";
import IPermitsPayments from "../IPermitsPayments";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsPayments implements IPermitsPayments {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	async register(creditCardProvider: CreditCardProvider, externalId: string, signal?: AbortSignal | undefined): Promise<string> {
		return this._client.textFetch(`payments/${creditCardProvider}/register`, "POST", null, {
			query: {
				"externalId": externalId
			},
			signal: signal
		});
	}
}
